<template>
  <page-template type="norightpanel" class="directory">
    <template v-slot:toolbar>
        <tool-bar type="directory" title="Annuaire des intervenants" class="px-8"></tool-bar>
    </template>
    <template v-slot:main-panel-content>
      <data-table
        text1="Intervenions effectuées : "
        number1="564"
        :headers="headers"
        :items="serviceproviders"
      >
        <template v-slot:category-icon>
          <img src="/images/icons_interventions/electricite.png" alt="" class="mr-2 data-table-icon category"/>
        </template>
        <template v-slot:quality-icon>
          <img src="/images/green_star.png" alt="" class="mr-2 data-table-icon"/>
        </template>
        <template v-slot:relational-icon>
          <img src="/images/red_star.png" alt="" class="mr-2 data-table-icon"/>
        </template>
      </data-table>
    </template>
  </page-template>
</template>

<script>
  import pageTemplate from '@/templates/PageTemplate.vue'
  import toolBar from '@/components/ToolBar.vue'
  import dataTable from '@/components/DataTable.vue'
  import axios from 'axios'
  import { apiURL } from '@/../config'
  export default {
    name: 'Annuaire',
    components: { pageTemplate, toolBar, dataTable },
    data: () => {
      return {
        headers: [
          { text: 'Catégorie', value: 'category' },
          { text: 'Société', value: 'serviceprovider' },
          { text: 'Adresse', value: 'address' },
          { text: 'Coordonnées', value: 'email' },
          { text: 'Interventions', value: 'intervention' },
          { text: 'Qualité', value: 'quality' },
          { text: 'Relationnel', value: 'relational' }
        ],
        serviceproviders: [
          {
            category: 'Electricité',
            serviceprovider: 'Powerlight',
            address: 'rue du moulin - 06000 Nice',
            email: 'powerlight@mail.fr',
            intervention: "Voir le suivi d'intervention",
            quality: '3/5',
            relational: '1/5'
          }
        ]
      }
    },
    async created () {
      try {
        // ALL SERVICE PROVIDERS
        const serviceProvidersRes = await axios.get(`${apiURL}/data/technicalProviders`)
        this.serviceproviders = serviceProvidersRes.data
        // SERVICE PROVIDER DETAIL
        const serviceProvidersDetailRes = await axios.get(`${apiURL}/data/technical/:id`)
        this.serviceproviders = serviceProvidersDetailRes.data
      } catch (e) {
        alert('Une erreur est survenue, veuillez réessayer.')
        console.log(e)
      }
    }
  }
</script>